import { type ReactNode } from 'react';

interface TimeAbbreviationProps {
    unit: string;
    abbreviation: string;
    short: string;
    long: string;
    guide?: ReactNode;
}

export const TimeAbbreviation = ({
    unit,
    abbreviation,
    short,
    long,
    guide = undefined,
}: TimeAbbreviationProps) => (
    <div className="sds_guidelines__container">
        <div style={{ width: '20%' }} className="sds_abbreviation__title">
            {unit}
        </div>
        <div style={{ width: '20%' }} className="sds_abbreviation__text">
            {abbreviation}
        </div>
        <div style={{ width: '20%' }} className="sds_abbreviation__text">
            {short}
        </div>
        <div style={{ width: '20%' }} className="sds_abbreviation__text">
            {long}
        </div>
        <div style={{ width: '20%' }} className="sds_abbreviation__text">
            {guide}
        </div>
    </div>
);
